export default "__VITE_ASSET__DBrSbeCO__"